
const PANMOVE = 'PANMOVE';
const PANEND = 'PANEND';
const CLICK = 'CLICK'
const SHOW_REPORT = 'MAP_SHOW_REPORT'
const HIDE_REPORT = 'MAP_HIDE_REPORT'


export function map(state = {}, action) {
  switch (action.type) {
    case PANMOVE:
    case PANEND:
    case CLICK:
    case SHOW_REPORT:
    case HIDE_REPORT:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export function panmove(data) {
  return { type: PANMOVE, payload: data }
}

export function panend(data) {
  return { type: PANEND, payload: data }
}

export function click(data) {
  return { type: CLICK, payload: data }
}
export function showReport(data) {
  return { type: SHOW_REPORT, payload: data }
}
export function hideReport(data) {
  return { type: HIDE_REPORT, payload: data }
}

